import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: '2em',
  },
  addSubsystemButton: {
    height: '6em',
  },
  subsystemHelperInlay: {
    '& div': {
      fontSize: 15,
    },
  },
  subsystemHelperButton: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',

    '& svg': {
      color: theme.palette.primary.main,
      marginRight: 5,
      marginLeft: 2,
    },
  },
}));

export default useStyles;
